import src from "IMAGE";
export default { src, width: 1068, height: 142, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/APB4bJD3t7BM8o2Cee9rXpzRgnmIgouKiIucnHRacnKlQJYSagQ+C64AAAAASUVORK5CYII="};
